import UTILITY_API from "../utility_api";

const getActivityCodesForPDPI = (pdpi, query) => {
  const matchingObjects = pdpi.filter((element) =>
    query.includes(element.pd_pi_citizenship_requirement)
  );

  const activityCodes = matchingObjects.map((obj) => ({
    pd_pi_citizenship_requirement: obj.pd_pi_citizenship_requirement,
    activity_codes: obj.activity_codes,
  }));

  return activityCodes.length > 0 ? activityCodes : null;
};

const fetchPDPI = async (pdpi_option) => {
  try {
    const pdpi = await fetch(UTILITY_API + "/pd_pi_citizenship");
    if (!pdpi.ok) {
      throw new Error(`First API call failed: ${pdpi.statusText}`);
    }
    const pdpi_data = await pdpi.json();
    const activityCodes = getActivityCodesForPDPI(pdpi_data, pdpi_option);

    if (activityCodes) {
      const flattenedActivityCodes = activityCodes.flatMap(
        (obj) => obj.activity_codes
      );
      let updateDataQuery = {
        activitycodes: flattenedActivityCodes.join(","),
      };
      return updateDataQuery;
    }
  } catch (error) {
    console.error("Failed to fetch data:", error);
  }
};

export const handlePDPIHelper = async (pd_pi) => {
  let updateDataQuery = await fetchPDPI(pd_pi);
  return updateDataQuery;
};
